"use client"

import { useRef } from "react"
import NextImage from "next/image"
import { motion, useInView } from "framer-motion"


import AdaniPorts from "@/public/clientLogo/adaniPorts.png";
import bharatForge from "@/public/clientLogo/bharatForge.png";
import sbi from "@/public/clientLogo/SBI-Mutual-Fund.png";
import Apraava from "@/public/clientLogo/Apraava.png";
import adaniRenewable from "@/public/clientLogo/adaniRenewable.png";
import godrej from "@/public/clientLogo/godrej.png";
import reliance from "@/public/clientLogo/reliance.png";


const clients = [
  { name: "godrej", img: godrej },
  { name: "Adani Ports", img: AdaniPorts },
  { name: "Bharat Forge", img: bharatForge },
  { name: "Apraava", img: Apraava },
  { name: "Sbi", img: sbi },
  { name: "adaniRenewable", img: adaniRenewable },
  { name: "reliance", img: reliance },


];

interface ClientsSectionProps {
  heading?: string
  subheading?: string
  description?: string
}

// Defaults are the homepage copy; service pages pass their own text from data/services.json.
export default function ClientsSection({
  heading = "Global brand we design ESG reports for",
  subheading = "Trusted by Fortune 500 companies worldwide to elevate their corporate communications",
  description = "We design reports for leading corporates, consultancies, and nonprofits around the world. Our clients choose us because we combine creative design with ESG expertise to deliver reports that inspire stakeholders.",
}: ClientsSectionProps) {
  const sectionRef = useRef<HTMLDivElement>(null)
  const isInView = useInView(sectionRef, { once: false, amount: 0.2, margin: "-100px" })

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  }

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  }

  return (
    <section ref={sectionRef} className="bg-gray-900 md:py-20 py-16" id="clients">
      <div className="container mx-auto px-4">
        <motion.div
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
          variants={containerVariants}
          className="text-center mb-16"
        >
          <motion.h2 variants={itemVariants} className="text-4xl md:text-5xl text-white font-bold mb-4">
            {heading}
          </motion.h2>
          <motion.p variants={itemVariants} className="text-lg text-gray-300 max-w-3xl mx-auto">
            {subheading}
          </motion.p>
        </motion.div>

        <motion.div
          variants={itemVariants}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
          className="overflow-hidden relative"
        >



          <div className="flex items-center justify-center gap-6 flex-wrap overflow-hidden w-full border-y border-y-gray-500 py-6">
            {/* Auto-scroll animation */}
            {/* <div className="flex animate-marquee whitespace-nowra"> */}
            {[...clients].map((client, index) => (
              <div key={index} className="flex items-center justify-center">
                <div className="relative flex items-center justify-center">
                  <NextImage
                    src={client?.img}
                    alt={client?.name}
                    width={130}
                    height={60}
                    style={{ objectFit: "contain" }}
                    quality={100}
                    priority
                    sizes="(max-width: 768px) 50vw, (max-width: 1200px) 33vw, 25vw"
                    className="object-contain filter invert"
                  />
                </div>
              </div>
            ))}
            {/* </div> */}
          </div>



        </motion.div>

        <motion.p variants={itemVariants} className="text-lg text-gray-300 mt-12 text-center max-w-4xl mx-auto">
          {description}
        </motion.p>

      </div>
    </section>
  )
}
